const MUTATION = 'mutation';
const MUTATION_ADD_COMMENT = 'addComment';
const MUTATION_APPROVE = 'approve';
const MUTATION_REJECT = 'reject';
const MUTATION_UNDO = 'undo';
const MUTATION_DELETE = 'delete';
const MUTATION_UPDATE = 'update';
const MUTATION_DEACTIVATE = 'deactivate';
const MUTATION_CREATE = 'create';
const MUTATION_ACTIVATE = 'activate';
const MUTATION_ARCHIVE = 'archive';
const MUTATION_RESTORE = 'restore';

export class MutationKey {
  constructor(...key) {
    this.entityKey = key;
  }
  getPath() {
    return this.entityKey;
  }

  mutate(key) {
    return () => [...this.entityKey, key, MUTATION];
  }
  activate() {
    return this.mutate(MUTATION_ACTIVATE);
  }
  addComment() {
    return this.mutate(MUTATION_ADD_COMMENT);
  }
  approve() {
    return this.mutate(MUTATION_APPROVE);
  }
  create() {
    return this.mutate(MUTATION_CREATE);
  }
  deactivate() {
    return this.mutate(MUTATION_DEACTIVATE);
  }
  delete() {
    return this.mutate(MUTATION_DELETE);
  }
  reject() {
    return this.mutate(MUTATION_REJECT);
  }
  undo() {
    return this.mutate(MUTATION_UNDO);
  }
  update() {
    return this.mutate(MUTATION_UPDATE);
  }
  archive() {
    return this.mutate(MUTATION_ARCHIVE);
  }
  restore() {
    return this.mutate(MUTATION_RESTORE);
  }
}
